<template>
  <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="学生志愿者" name="first">
      <v-stu-appoint volunterType="2"></v-stu-appoint>
    </el-tab-pane>
    <el-tab-pane label="小志愿者" name="second">
      <v-stu-appoint volunterType="3" ></v-stu-appoint>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import littleAppoint from './little-volunteer-appoint'
import stuAppoint from './stu-volunteer-appoint'
export default {
  components: {
    'v-little-appoint': littleAppoint,
    'v-stu-appoint': stuAppoint
  },
  data() {
    return {
      activeName: "first",
      guideId: "",
      list: []
    }
  },

  methods: {
    handleClick() {
    },

  },

  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  /deep/.el-tabs__nav-wrap {
    &::after{
      display: none;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }
}
</style>